import React from 'react';

/** The id carried by every route's `<main>` landmark — the layouts' and
 *  BareLayout's main target this anchor, so the skip target resolves on
 *  whichever layout (or none) the route renders inside. */
export const MAIN_CONTENT_ID = 'main-content';

/** The skip link: the first focusable element of every route (App.tsx renders
 *  it ahead of everything else), visually hidden until focused. Hidden with
 *  `sr-only` — not `display:none` and not a conditional render — so it stays
 *  focusable, and therefore reachable by a first Tab, on every route. */
export const SkipLink: React.FC = () => (
  <a
    href={`#${MAIN_CONTENT_ID}`}
    className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-gray-900 focus:rounded-md focus:shadow-lg focus:border"
  >
    Skip to main content
  </a>
);
